import { ItemList, WithContext } from 'schema-dts';
import MainJsonLD from './main';
import { SchemaIds } from './prepIds';

interface Props {
  prices: {
    name: string;
    description?: string;
    price?: string;
    currency?: string;
  }[];
  overrideJson?: string;
  ids: SchemaIds;
}

export function PriceSpecificationJsonLd({ prices, overrideJson, ids }: Props) {
  if (overrideJson) return <MainJsonLD json={overrideJson} />;

  const { id, orgId } = ids;

  const jsonLd: WithContext<ItemList> = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    '@id': id,
    itemListElement: prices.map((p, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@type': 'Offer',
        name: p.name,
        description: p.description,
        offeredBy: orgId
          ? {
              '@id': orgId,
            }
          : undefined,
        priceSpecification: {
          '@type': 'PriceSpecification',
          price: p.price || '0.00',
          priceCurrency: p.currency || 'PLN',
        },
      },
    })),
  };

  return <MainJsonLD jsonLd={jsonLd} />;
}
